__webpack_require__.p = "/ERC20-Staking-Dapp-with-Swap-Stake-USDC-Faucet/";